import { UserGroup } from "../enums";

 export interface IListItem {
    id: number;
    description: string;
    abbreviation?: string;
    value?: string,
    sortOrder?: number,
    userGroups?: UserGroup[],
    isActive?: boolean,
    isRequired?: number
}
